export const GET_JOBS_REQUEST = "GET_JOBS_REQUEST";
export const GET_JOBS_RESPONSE = "GET_JOBS_RESPONSE";
